import React, { useState, useEffect } from 'react';
;
import { Card, CardContent, MuiTitle, Tabs, TabList, Tab, TabLink } from 'src/ui/mui-ui-kit';;
import { useNavigate } from 'react-router-dom';
import propTypes from 'prop-types';
import { FISettingsPage } from './FISettingsPage';
import { ComplianceSettingsPage } from './ComplianceSettingsPage';
import { NotificationSettingsPage } from './NotificationSettingsPage';
import { UiSpacer } from '../../ui';
import {
  SETTINGS_TAB_INDICES_PRIMARY,
  SETTINGS_TAB_INDICES_FI,
} from '../const';

/* eslint-disable no-unused-expressions */

export function SettingsPage({ isExpanded, user, account }) {
  const navigate = useNavigate();
  const [filteredSettings, setFilteredSettings] = useState(
    SETTINGS_TAB_INDICES_FI
  );
  const [activeTab, setActiveTab] = useState(
    user.isPrimaryBankAdmin
      ? SETTINGS_TAB_INDICES_PRIMARY.FI
      : filteredSettings.Notifications
  );

  useEffect(() => {
    if (user) {
      if (user.isPrimaryBankAdmin) {
        setFilteredSettings(SETTINGS_TAB_INDICES_PRIMARY);
      }
    }
  }, []);
  return (
    <>
      <Card className="review-and-submit">
        <CardContent>
          <MuiTitle isSize={3}>Settings</MuiTitle>

          <UiSpacer />

          <Tabs isToggle className="no-shadow no-margin">
            <TabList>
              {Object.keys(filteredSettings).map(idx => (
                <Tab isActive={filteredSettings[idx] === activeTab} key={idx}>
                  <TabLink onClick={() => setActiveTab(filteredSettings[idx])}>
                    {filteredSettings[idx]}
                  </TabLink>
                </Tab>
              ))}
            </TabList>
          </Tabs>
        </CardContent>
      </Card>
      <UiSpacer />
      {/* <Card> */}
      {/* <CardContent> */}
      {activeTab === filteredSettings.FI && (
        <FISettingsPage
          isExpanded={isExpanded}
          user={user}
          account={account}
        />
      )}

      {activeTab === filteredSettings.Compliance && <ComplianceSettingsPage />}
      {activeTab === filteredSettings.Notifications && (
        <NotificationSettingsPage />
      )}
      {/* </CardContent> */}
      {/* </Card> */}
    </>
  );
}

SettingsPage.defaultProps = {
  account: {},
};
SettingsPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object,
};
